<template>
  <div class="error-page">
    <div class="error-page__content">
      <img src="../assets/img/huntica.svg" alt="Huntica" class="error-page__logo">
      <div class="error-page__code">404</div>
      <h1 class="error-page__title">
        {{ $t('title') }}
      </h1>
      <p class="error-page__text">
        {{ $t('description') }}
      </p>
      <a :href="homeUrl" class="error-page__btn">
        {{ $t('action') }}
      </a>
    </div>
  </div>
</template>

<script>
import useHomeUrl from '@/compositions/useHomeUrl';

export default {
  name: 'VideoRoomErrorPage',
  metaInfo() {
    return { title: this.$t('pageTitle') };
  },
  setup() {
    return useHomeUrl();
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #EBF4FF 0%, #F0F8FF 100%);
  padding: 2rem;
}

.error-page__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 28rem;
}

.error-page__logo {
  height: 2rem;
  margin-bottom: 2.5rem;
  opacity: 0.7;
}

.error-page__code {
  font-size: 6rem;
  font-weight: 700;
  line-height: 1;
  background: linear-gradient(135deg, #0A82D9 0%, #00CBF3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
}

.error-page__title {
  font-size: 1.375rem;
  font-weight: 500;
  color: #1A1A2E;
  margin-bottom: 0.75rem;
}

.error-page__text {
  font-size: 0.9375rem;
  font-weight: 300;
  color: #6B8BAF;
  line-height: 1.6;
  margin-bottom: 2.5rem;
}

.error-page__btn {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #FFFFFF;
  text-decoration: none;
  background: linear-gradient(135deg, #0A82D9 0%, #00CBF3 100%);
  border-radius: 8px;
  padding: 0.75rem 2rem;
  box-shadow: 0 3px 12px rgba(10, 130, 217, 0.35);
  transition: box-shadow 0.25s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 5px 20px rgba(10, 130, 217, 0.45);
    transform: translateY(-1px);
    color: #FFFFFF;
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
  }
}
</style>

<i18n locale="en" lang="yaml">
pageTitle: Page not found
title: Link is invalid or expired
description: The interview link you followed doesn't exist or has already expired. Please check the link or contact the person who invited you.
action: Go to Huntica
</i18n>

<i18n locale="ru" lang="yaml">
pageTitle: Страница не найдена
title: Ссылка недействительна или устарела
description: Ссылка на собеседование не существует или срок её действия истёк. Проверьте ссылку или обратитесь к тому, кто вас пригласил.
action: Перейти на Huntica
</i18n>
